import type { Dtos } from "@inrev/common";

export const sfaaClassExperienceQueryKey = () => ["sfaa-class-experience"] as const;

export const sfaaClassExperienceImportsQueryKey = () =>
	[...sfaaClassExperienceQueryKey(), "imports"] as const;

export type SfaaClassExperienceRowsQuery = Omit<
	Dtos.Admin.SfaaClassExperience.List.Request,
	"limit" | "offset"
>;

export const sfaaClassExperienceRowsQueryKey = (query: SfaaClassExperienceRowsQuery) =>
	[...sfaaClassExperienceQueryKey(), "rows", query] as const;

export const sfaaClassExperienceFiltersQueryKey = () =>
	[...sfaaClassExperienceQueryKey(), "filters"] as const;

export type SfaaClassExperienceSeriesQuery = Dtos.Admin.SfaaClassExperience.Series.Request;

export const sfaaClassExperienceSeriesQueryKey = (query: SfaaClassExperienceSeriesQuery) =>
	[...sfaaClassExperienceQueryKey(), "series", query] as const;
